export const RIDER_LOADING = 'RIDER_LOADING';
export const INIT_RIDERS = 'INIT_RIDERS';
export const INIT_RIDER_REPORT = 'INIT_RIDER_REPORT';